export const ROOT_PAGE_SLUG = "-";
export const EMERGENCY_HELP_SLUG = "emergency-help";
